import Vue from "vue";
import moment from "moment-timezone";

Vue.filter("datetime", function (value) {
  if (!value) return "";
  return moment(value).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm:ss");
});

Vue.filter("date", function (value) {
  if (!value) return "";
  return moment(value).tz("America/Sao_Paulo").format("DD/MM/YYYY");
});

Vue.filter("time", function (value) {
  if (!value) return "";
  return moment(value).tz("America/Sao_Paulo").format("HH:mm:ss");
});

Vue.filter("formatSize", function (size) {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
  } else if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
  } else if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + " MB";
  } else if (size > 1024) {
    return (size / 1024).toFixed(2) + " KB";
  }
  return size.toString() + " B";
});
